module.exports = __webpack_public_path__ + "static/scale-model-of-aurora-downtown-in-aurora-illinois-72a266f37af1769ef96cd99a756c4e42.png";